import React, { useEffect, useState } from "react"

import { Link, useLocation, useNavigate } from "react-router-dom"
import {
  Box,
  List,
  Typography,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Tooltip,
} from "@mui/material"

import { DashBoardIcon } from "./Atom"
import { setGroupDetailsPracticeresult } from "../../redux/slices/groupProfileSlice"
import { useDispatch } from "react-redux"
import PermsWrapper from "../Auth/PermsWrapper"
import { setSelectedBlueprintMetricsEmpty } from "../../redux/slices/metricSlice"
import { colors } from "../../../styles/commonStyles"
import { useUnsavedChanges } from "../../hooks"
import { UnsavedChangesModal } from "../Modal"
import { clearTabChanges } from "../../redux/slices/resourceBudgetSlice"

type DrawerItemProps = {
  open: any
  isSelected: any
  navLinkEnd: any
  disabled: any
  item: any
  itemTitle: any
  DisplayIcon: any
  handleDrawerClose: any
  willCollapseSidebar: any
  perm: any
  standOut?: boolean
}

const DrawerItem = (props: DrawerItemProps) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const { hasUnsavedChanges } = useUnsavedChanges()
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(
    null,
  )

  const {
    open,
    isSelected,
    navLinkEnd,
    disabled,
    item,
    itemTitle,
    DisplayIcon,
    handleDrawerClose,
    willCollapseSidebar,
    perm,
    standOut,
  } = props

  useEffect(() => {
    if (item == "metric") {
      dispatch(setSelectedBlueprintMetricsEmpty())
    }
  }, [])

  const handleNavigation = (e: React.MouseEvent) => {
    // If we're already on the target page, don't show warning
    if (location.pathname === navLinkEnd) {
      return
    }

    // If there are unsaved changes and we're navigating away from resource budget
    if (hasUnsavedChanges) {
      e.preventDefault()
      setPendingNavigation(navLinkEnd)
      setShowUnsavedModal(true)
    }
  }

  const handleConfirmNavigation = () => {
    // Clear all dirty cells and changes
    dispatch(clearTabChanges({ tabKey: "clinicalDoctors" }))
    dispatch(clearTabChanges({ tabKey: "clinicalHygienists" }))
    dispatch(clearTabChanges({ tabKey: "nonClinical" }))

    setShowUnsavedModal(false)
    if (pendingNavigation) {
      navigate(pendingNavigation)
      setPendingNavigation(null)
    }
  }

  const handleCancelNavigation = () => {
    setShowUnsavedModal(false)
    setPendingNavigation(null)
  }

  return (
    <>
      <PermsWrapper perm={perm}>
        <Link
          to={navLinkEnd}
          style={{
            textDecoration: "none",
            pointerEvents: disabled ? "none" : "auto",
          }}
          onClick={handleNavigation}
        >
          <List>
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                className="MenuItem"
                selected={location.pathname == navLinkEnd}
                disabled={disabled}
                sx={{
                  height: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  py: 0,
                  m: 0,
                  color: standOut ? colors.primaryOrange : colors.starkWhite,
                  "&.Mui-selected": {
                    color: standOut
                      ? colors.primaryOrange
                      : colors.selectedBlue,
                  },
                  "&.Mui-selected:hover": {
                    color: standOut
                      ? colors.primaryOrange
                      : colors.selectedBlue,
                  },
                  // "&.Mui-focusVisible": {
                  //     backgroundColor: "#9B9898",
                  //     color: "#031741",
                  // },
                  // ":hover": {
                  //   backgroundColor: standOut
                  //     ? colors.primaryOrange
                  //     : "transparent",
                  // },
                  // backgroundColor: standOut
                  //   ? colors.primaryOrange
                  //   : "transparent",
                }}
              >
                <Tooltip title={itemTitle} placement="right-start">
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      height: "100%",
                      alignItems: "center",
                      display: "flex",
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <DisplayIcon isSelected={isSelected[item]} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: "14px" }}>
                      {itemTitle}
                    </Typography>
                  }
                  sx={{
                    opacity: open ? 1 : 0,
                    whiteSpace: open ? "pre-wrap" : "normal",
                  }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Link>
      </PermsWrapper>

      <UnsavedChangesModal
        open={showUnsavedModal}
        onConfirm={handleConfirmNavigation}
        onCancel={handleCancelNavigation}
        title="Unsaved Changes"
        message="You have unsaved changes in Resource Budget that will be lost. Do you want to continue?"
      />
    </>
  )
}

export default DrawerItem
